/*! Broadcast - Shipping Calculator (Uhnika: CEP→UF, BR fixo, ETA em dias úteis, Free visual strike-through) */
!function(){ "use strict";

/* ===== UFs e faixas de CEP ===== */
var BR_UF=[{code:"AC",name:"Acre"},{code:"AL",name:"Alagoas"},{code:"AP",name:"Amapá"},{code:"AM",name:"Amazonas"},{code:"BA",name:"Bahia"},{code:"CE",name:"Ceará"},{code:"DF",name:"Distrito Federal"},{code:"ES",name:"Espírito Santo"},{code:"GO",name:"Goiás"},{code:"MA",name:"Maranhão"},{code:"MT",name:"Mato Grosso"},{code:"MS",name:"Mato Grosso do Sul"},{code:"MG",name:"Minas Gerais"},{code:"PA",name:"Pará"},{code:"PB",name:"Paraíba"},{code:"PR",name:"Paraná"},{code:"PE",name:"Pernambuco"},{code:"PI",name:"Piauí"},{code:"RJ",name:"Rio de Janeiro"},{code:"RN",name:"Rio Grande do Norte"},{code:"RS",name:"Rio Grande do Sul"},{code:"RO",name:"Rondônia"},{code:"RR",name:"Roraima"},{code:"SC",name:"Santa Catarina"},{code:"SP",name:"São Paulo"},{code:"SE",name:"Sergipe"},{code:"TO",name:"Tocantins"}];
var CEP_RANGES=[{start:1000,end:19999,uf:"SP"},{start:20000,end:28999,uf:"RJ"},{start:29000,end:29999,uf:"ES"},{start:30000,end:39999,uf:"MG"},{start:40000,end:48999,uf:"BA"},{start:49000,end:49999,uf:"SE"},{start:50000,end:56999,uf:"PE"},{start:57000,end:57999,uf:"AL"},{start:58000,end:58999,uf:"PB"},{start:59000,end:59999,uf:"RN"},{start:60000,end:63999,uf:"CE"},{start:64000,end:64999,uf:"PI"},{start:65000,end:65999,uf:"MA"},{start:66000,end:68899,uf:"PA"},{start:68900,end:68999,uf:"AP"},{start:69000,end:69299,uf:"AM"},{start:69300,end:69399,uf:"RR"},{start:69400,end:69899,uf:"AM"},{start:69900,end:69999,uf:"AC"},{start:70000,end:72799,uf:"DF"},{start:72800,end:72999,uf:"GO"},{start:73000,end:73699,uf:"DF"},{start:73700,end:76799,uf:"GO"},{start:76800,end:76999,uf:"RO"},{start:77000,end:77999,uf:"TO"},{start:78000,end:78899,uf:"MT"},{start:79000,end:79999,uf:"MS"},{start:80000,end:87999,uf:"PR"},{start:88000,end:89999,uf:"SC"},{start:90000,end:99999,uf:"RS"}];
function cepToUF(cep){if(!cep)return null;var d=String(cep).replace(/\D/g,"");if(d.length<5)return null;var n=parseInt(d.slice(0,5),10);for(var i=0;i<CEP_RANGES.length;i++){var r=CEP_RANGES[i];if(n>=r.start&&n<=r.end)return r.uf}if(/^[01]/.test(d))return"SP";return null}

/* ===== Utils ===== */
const qs=(obj,path=[],arr=false)=>{const r=Object.keys(obj).map(k=>{let v=obj[k];if(Object.prototype.toString.call(v)==='[object Object]'||Array.isArray(v)){if(Array.isArray(obj))path.push('');else path.push(k);return qs(v,path,Array.isArray(v))}else{let key=k;if(path.length>0){key=(arr?path:[...path,k]).reduce((acc,cur)=>acc===''?cur:`${acc}[${cur}]`,'')}return arr?`${key}[]=${v}`:`${key}=${v}`}}).join('&');path.pop();return r};
function daysUntilISO(isoStr){try{var d;if(/^\d{4}-\d{2}-\d{2}$/.test(isoStr)){var p=isoStr.split('-');d=new Date(p[0],parseInt(p[1],10)-1,p[2])}else{d=new Date(isoStr)}var today=new Date();today.setHours(0,0,0,0);var target=new Date(d.getFullYear(),d.getMonth(),d.getDate());var ms=target-today;var days=Math.ceil(ms/86400000);return days<0?0:days}catch(e){return null}}
function HttpError(opts){this.status=opts.status||null;this.headers=opts.headers||null;this.json=opts.json||null;this.body=opts.body||null} HttpError.prototype=Error.prototype;

/* ===== Seletores/constantes ===== */
const BTN_SEL=".get-rates", PROVINCE_SEL="#address_province", ZIP_SEL="#address_zip", WRAPPER_SEL="#wrapper-response", TEMPLATE_SEL="#shipping-calculator-response-template";
const NO_SHIPPING_SELECTOR="[data-template-no-shipping]", ATTR_NO_SHIPPING="data-template-no-shipping";
const CLS_HIDDEN="is-hidden", CLS_ERROR="error", CLS_CENTER="center", CLS_SUCCESS="success", CLS_DISABLED="disabled", CLS_TRIGGER="get-rates--trigger";
const ERR_COUNTRY_UNSUPPORTED="Error : country is not supported.", MSG_DOESNT_SHIP="We do not ship to this destination.", ERR_PREFIX="Error : ";

/* ===== Componente ===== */
class ShippingCalculator extends HTMLElement{
  constructor(){
    super();
    this.getRatesButton=this.querySelector(BTN_SEL);
    this.selectProvince=this.querySelector(PROVINCE_SEL);
    this.template=this.querySelector(TEMPLATE_SEL);
    this.wrapper=this.querySelector(WRAPPER_SEL);
    this.onButtonClickEvent=()=>this.onButtonClick();
    this._lastCepDigits=null;         // guarda CEP (só dígitos)
    this._isFreeVisualEligible=false; // CEP elegível à regra visual (SP)
  }

  connectedCallback(){
    // Popular UF no select oculto (para a API)
    if(this.selectProvince){
      const frag=document.createDocumentFragment();
      BR_UF.forEach(uf=>{const o=document.createElement("option");o.value=uf.code;o.textContent=uf.name;frag.appendChild(o)});
      this.selectProvince.innerHTML=""; this.selectProvince.appendChild(frag);
    }
    if(this.getRatesButton){
      this.getRatesButton.addEventListener("click",this.onButtonClickEvent);
      if(theme.settings.customerLoggedIn && this.getRatesButton.classList.contains(CLS_TRIGGER)){
        const zip=document.querySelector(ZIP_SEL); if(zip&&zip.value) this.getRatesButton.dispatchEvent(new Event("click"));
      }
    }
  }
  disconnectedCallback(){ if(this.getRatesButton) this.getRatesButton.removeEventListener("click",this.onButtonClickEvent) }

  onButtonClick(){
    this.disableButtons();
    while(this.wrapper.firstChild) this.wrapper.removeChild(this.wrapper.firstChild);
    this.wrapper.classList.add(CLS_HIDDEN);

    // País fixo BR
    const country="BR";

    // CEP/UF
    const cepDigits=(document.querySelector(ZIP_SEL).value||"").replace(/\D/g,"");
    let uf=cepToUF(cepDigits);
    if(!uf && this.selectProvince && this.selectProvince.options.length){ uf=this.selectProvince.options[0].value }
    if(this.selectProvince) this.selectProvince.value=uf||"";

    // flags para render
    this._lastCepDigits=cepDigits;
    this._isFreeVisualEligible = !!cepDigits && /^[01]/.test(cepDigits); // sua regra: CEP iniciando com 0 ou 1

    const dest={ zip: cepDigits, country: country, province: uf || "" };
    this.getCartShippingRatesForDestination(dest);
  }

  /* === Preço — detecta R$ 0 como Frete grátis === */
  formatRate(raw){
    var cents;
    if(typeof raw==="number"){ if(raw>0&&raw<1)cents=Math.round(raw*100); else if(raw%1!==0)cents=Math.round(raw*100); else cents=raw; }
    else if(typeof raw==="string"){ var f=parseFloat(raw.replace(",",".")); cents=isNaN(f)?0:Math.round(f*100); }
    else { cents=0; }
    if(cents===0) return (window.theme&&window.theme.strings&&window.theme.strings.free)?window.theme.strings.free:"Frete grátis";
    return window.theme&&window.theme.formatMoney?window.theme.formatMoney(cents,theme.moneyFormat):(cents/100).toFixed(2);
  }

  /* === Tempo — força “dias úteis” em todos os caminhos === */
  etaFromRate(rate){
    if(!rate) return "";
    if(rate.delivery_range && (rate.delivery_range.min||rate.delivery_range.max)){
      var max=rate.delivery_range.max||rate.delivery_range.min;
      if(typeof max==="number"&&max>=0) return `em até ${max} dias úteis`;
    }
    var days=rate.delivery_days||rate.estimated_days||rate.days;
    if(typeof days==="number"&&days>=0) return `em até ${days} ${days===1?"dia útil":"dias úteis"}`;
    if(typeof days==="string"&&days){
      var n=parseInt(days,10);
      if(!isNaN(n)) return `em até ${n} ${n===1?"dia útil":"dias úteis"}`;
      var range=days.match(/^(\d+)\s*[-–]\s*(\d+)$/);
      if(range) return `em até ${parseInt(range[2],10)} dias úteis`;
    }
    var iso=rate.estimated_delivery||rate.delivery_date||(rate.delivery_range&&(rate.delivery_range.max_date||rate.delivery_range.min_date));
    if(iso){
      var isoVal=Array.isArray(iso)?iso[0]:(typeof iso==="object"?(iso.max_date||iso.min_date):iso);
      if(isoVal&&/^\d{4}-\d{2}-\d{2}/.test(String(isoVal))){
        var dd=daysUntilISO(String(isoVal));
        if(dd!==null) return `em até ${dd} dias úteis`;
      }
    }
    var txt=rate.etd||rate.delivery_time||rate.lead_time;
    if(txt) return String(txt);
    return "";
  }

  /* === Render com suporte a grátis riscado === */
  render(payload){
    if(!(this.template&&this.wrapper)) return;

    this.wrapper.innerHTML="";
    let listHtml="", feedbackText="", statusClass=CLS_ERROR+" "+CLS_CENTER;
    let tpl=this.template.innerHTML;
    const betweenBrackets=/[^[\]]+(?=])/g;

    // helpers
    const liTemplate=payload.rates&&payload.rates.length ? betweenBrackets.exec(tpl)[0] : "";

    // analisa tarifas
    const rates = Array.isArray(payload.rates)?payload.rates:[];
    const paidRates = rates.filter(r=>{ // preço > 0
      const p = (typeof r.price==="number")?r.price:parseFloat(String(r.price).replace(",","."))*100;
      return (typeof r.price==="number" ? r.price : p) > 0;
    });
    // mais barata paga
    let cheapestPaid=null, cheapestPaidCents=null;
    paidRates.forEach(r=>{
      let cents;
      if(typeof r.price==="number"){ cents=r.price%1!==0?Math.round(r.price*100):r.price; }
      else { const f=parseFloat(String(r.price).replace(",",".")); cents=isNaN(f)?Infinity:Math.round(f*100); }
      if(cheapestPaid===null || cents<cheapestPaidCents){ cheapestPaid=r; cheapestPaidCents=cents; }
    });
    const hasFreeAPI = rates.some(r=>{
      if(typeof r.price==="number"){ return (r.price%1!==0?Math.round(r.price*100):r.price)===0; }
      const f=parseFloat(String(r.price).replace(",",".")); return !isNaN(f) && Math.round(f*100)===0;
    });

    // Monta linhas normais (com possível ajuste na rate grátis vinda da API)
    rates.forEach((rate)=>{
      const priceText = this.formatRate(rate.price);
      const isFree = (typeof rate.price==="number"? (rate.price%1!==0?Math.round(rate.price*100):rate.price)===0
                     : (function(){const f=parseFloat(String(rate.price).replace(",","."));return !isNaN(f)&&Math.round(f*100)===0})());
      const nameText  = isFree ? "Frete grátis" : (rate.presentment_name||rate.name);
      let etaText     = this.etaFromRate(rate);

      let priceHTML = priceText;
      if(isFree){
        // se API já deu grátis: risca preço da mais barata paga (se existir)
        const cheapestPaidPriceHTML = cheapestPaid ? this.formatRate(cheapestPaid.price) : "";
        priceHTML = cheapestPaid ? `<span class="uh-free"><s>${cheapestPaidPriceHTML}</s> <strong>Grátis</strong></span>` : `<span class="uh-free"><strong>Grátis</strong></span>`;
        if(!etaText && cheapestPaid){ etaText = this.etaFromRate(cheapestPaid); }
      }

      let li=liTemplate;
      li=li.replace(/\|\|rateName\|\|/, nameText);
      li=li.replace(/\|\|ratePrice\|\|/, priceHTML);
      li=li.replace(/\|\|rateEta\|\|/, etaText||"");
      listHtml += li;
    });

    // Se não há rate grátis na API, mas o CEP é elegível (regra visual),
    // sintetiza uma linha "Frete grátis" com preço riscado + ETA da mais barata paga.
    if(!hasFreeAPI && this._isFreeVisualEligible && cheapestPaid){
      const synthName = "Frete grátis";
      const synthPrice = `<span class="uh-free"><s>${this.formatRate(cheapestPaid.price)}</s> <strong>Grátis</strong></span>`;
      const synthEta = this.etaFromRate(cheapestPaid);

      let li=liTemplate;
      li=li.replace(/\|\|rateName\|\|/, synthName);
      li=li.replace(/\|\|ratePrice\|\|/, synthPrice);
      li=li.replace(/\|\|rateEta\|\|/, synthEta||"");
      // coloca no topo
      listHtml = li + listHtml;
    }

    if(payload.success){
      statusClass=CLS_SUCCESS+" "+CLS_CENTER;
      const ghost=document.createElement("div"); ghost.innerHTML=this.template.innerHTML;
      const noShipEl=ghost.querySelector(NO_SHIPPING_SELECTOR);
      if(rates.length<1 && noShipEl){ feedbackText=noShipEl.getAttribute(ATTR_NO_SHIPPING); }
      else { feedbackText=theme.strings&&theme.strings.shippingCalcRates?theme.strings.shippingCalcRates:""; }
    }else{
      feedbackText=payload.errorFeedback;
    }

    // aplica no template
    tpl=tpl.replace(betweenBrackets,"").replace("[]","");
    tpl=tpl.replace(/\|\|ratesList\|\|/g,listHtml);
    tpl=tpl.replace(/\|\|successClass\|\|/g,statusClass);
    tpl=tpl.replace(/\|\|ratesText\|\|/g,feedbackText);

    this.wrapper.innerHTML+=tpl;
    this.wrapper.classList.remove(CLS_HIDDEN);
  }

  enableButtons(){ this.getRatesButton.removeAttribute("disabled"); this.getRatesButton.classList.remove(CLS_DISABLED); this.getRatesButton.textContent=theme.strings.shippingCalcSubmitButton; }
  disableButtons(){ this.getRatesButton.setAttribute("disabled","disabled"); this.getRatesButton.classList.add(CLS_DISABLED); this.getRatesButton.textContent=theme.strings.shippingCalcSubmitButtonDisabled; }

  getCartShippingRatesForDestination(dest){
    const query=encodeURI(qs({shipping_address:dest}));
    const url=`${theme.routes.cart_url}/shipping_rates.json?${query}`;
    fetch(url)
      .then(this.handleErrors)
      .then(r=>r.text())
      .then(txt=>{ const rates=JSON.parse(txt).shipping_rates; this.onCartShippingRatesUpdate(rates,dest); })
      .catch(err=>{ this.onError(err.json); });
  }

  fullMessagesFromErrors(errors){ const out=[]; for(const k in errors){ for(const msg of errors[k]) out.push(msg); } return out; }
  handleErrors(resp){ if(resp.ok) return resp; return resp.json().then(function(json){ throw new HttpError({status:resp.statusText,headers:resp.headers,json:json}); }); }
  onError(json){ this.enableButtons(); let msg=""; msg=json&&json.message?`${json.message}(${json.status}): ${json.description}`:(ERR_PREFIX+this.fullMessagesFromErrors(json).join("; ")); if(msg===ERR_COUNTRY_UNSUPPORTED) msg=MSG_DOESNT_SHIP; this.render({rates:[],errorFeedback:msg,success:false}); }
  onCartShippingRatesUpdate(rates){ this.enableButtons(); this.render({rates:rates,success:true}); }
}

customElements.get("shipping-calculator")||customElements.define("shipping-calculator",ShippingCalculator);
}();
